import blendOnto from './Flatlay/blendOnto'

const cachedImages = {}

//	Brand based blending options
const brandBlendOptions = {
	maap: { r: 224, b: 224, g: 224 },
	biehler: { r: 236, b: 236, g: 236 }
}

//	Creates a square version of the image as PNG
const squarizeImage = ({ img, maxSquare, blendOptions, callback }) => {
	const canvas = global.document.createElement('canvas')
	const ctx = canvas.getContext('2d')
	ctx.drawImage(img, 0, 0)

	let max = img.width > img.height ? img.width : img.height
	max = (maxSquare && max > maxSquare) ? maxSquare : max
	let width = img.width
	let height = img.height

	if (width > height) {
		if (width > max) {
			height *= max / width
			width = max
		}
	} else if (height > max) {
		width *= max / height
		height = max
	}
	canvas.width = max
	canvas.height = max
	ctx.drawImage(img, parseInt((max - width) / 2, 10), parseInt((max - height) / 2, 10), width, height)

	//	Create image as blendable
	blendOnto(ctx, ctx, 'blendif', blendOptions || {})

	const dataurl = canvas.toDataURL('image/png')
	const newImg = global.document.createElement('img')
	newImg.src = dataurl
	newImg.onload = function squareImageLoaded() { // eslint-disable-line func-names
		callback(this)
	}
	return newImg
}

const downloadImages = ({ imageUrls, imageOptions = {}, maxSquare, skipSquarize, skipCache }) => new Promise((resolve) => {
	const imageInstances = []
	const cbBinder = (index, url, imgsToLoad) => (img) => {
		imageInstances[index] = img
		cachedImages[url] = imageInstances[index]
		if (imgsToLoad === 0) {
			resolve(imageInstances)
		}
	}
	let imgsToLoad = imageUrls.length
	imageUrls.forEach((url, index) => {
		if (!url) {
			imgsToLoad -= 1
		} else if (skipCache || !cachedImages[url]) {
			const image = document.createElement('img')
			// eslint-disable-next-line func-names
			image.onload = function imageLoaded() {
				imgsToLoad -= 1
				if (skipSquarize) {
					cbBinder(index, url, imgsToLoad)(this)
				} else {
					const blendOptions = imageOptions[index] && brandBlendOptions[imageOptions[index].brandKey] ? brandBlendOptions[imageOptions[index].brandKey] : {}
					squarizeImage({ img: this, maxSquare, blendOptions, callback: cbBinder(index, url, imgsToLoad) })
				}
			}
			// eslint-disable-next-line func-names
			image.onerror = function imageOnError() {
				imgsToLoad -= 1
			}
			image.crossOrigin = ''
			image.src = url
		} else {
			imgsToLoad -= 1
			imageInstances[index] = cachedImages[url]
		}
	})
	if (imgsToLoad === 0) {
		resolve(imageInstances)
	}
})

export default downloadImages



// WEBPACK FOOTER //
// ./src/utilities/downloadImages.js